const Paths = {
  HOME: "/",
  LOGIN: "/login",
  SIGNUP: "/signup",
  AGENCY: "/agency",
  MY_ACCOUNT: "/me",
  MAP: "/map",
  LIVESTREAM: "/live",

  DEVICE_DASHBOARD: "/device/:device_id",
  DEVICE_FILE: "/device/:device_id/files",
  DEVICE_PLAYLISTS: "/device/:device_id/playlists",
  DEVICE_LIVE: "/device/:device_id/live",
  DEVICE_BROADCASTS: "/device/:device_id/broadcasts",
  DEVICE_STREAMER: "/device/:device_id/streamer",
  DEVICE_STREAM_CHANNELS: "/device/:device_id/stream-channels", // Digital Channels
  DEVICE_REPORTS: "/device/:device_id/reports",

  NODE_DASHBOARD: "/node/:node_id",
  NODE_TV: "/node/:node_id/tv",
  NODE_LIVE: "/node/:node_id/live",
  NODE_STREAMER: "/node/:node_id/streamer",
  NODE_BROADCASTS: "/node/:node_id/broadcasts",
  NODE_INFO: "/node/:node_id/info",
  NODE_SETTING: "/node/:node_id/settings",
  NODE_TIMER: "/node/:node_id/timers",
  NODE_CONTROL: "/node/:node_id/control",
  //
  NODE_CLOUD_STATIONS: "/node/:node_id/cloud-stations",
  NODE_CLOUD_WORKER: "/node/:node_id/cloud-worker",
  NODE_CLOUD_STATION_DETAIL: "/node/:node_id/cloud-stations/:station_id",

  CHILD_AGENCY_HOME: "/agency/:agency_id",
  CHILD_AGENCY_USERS: "/agency/:agency_id/users",
  CHILD_AGENCY_USER_GROUPS: "/agency/:agency_id/user-groups",

  PLAYLIST_VIEWER: "/playlist/:playlist_id",

  PUBLIC_SHORTCUT: "/p/:shortcut",
  PUBLIC_CONTROL: "/c/:shortcut",
  CLOUD_STATION_SHARING: "/s/:sharingKey",

  NOTFOUND: "*",

  AQI_HOME: "/aqi",
  AQI_DETAIL: "/aqi/node",
  AQI_DETAIL_SLUG: "/aqi/node/:node_slug",
}

export default Paths;